export default "__VITE_PUBLIC_ASSET__2c0d7ba1__"